import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import SEOHead from '@/components/base/SEOHead';
import { categories } from '@/mocks/categories';
import { getFeaturedArticles } from '@/mocks/articles';

const faqItems = [
  {
    question: '什么是亲密发声训练？',
    answer: '亲密发声训练是一套系统的方法，帮助成年伴侣在亲密互动中更自然、更丰富地进行声音表达。它涵盖了呼吸控制、声音技巧、心理调适和伴侣沟通等多个维度，旨在提升亲密关系的质量和双方的满意度。',
  },
  {
    question: '亲密发声训练适合什么样的人？',
    answer: '亲密发声训练适合所有希望提升亲密互动质量的成年伴侣。无论您是希望在亲密关系中更自由地表达自己，还是想增进与伴侣之间的情感连接，或是单纯对声音表达艺术感兴趣，都能从中获益。',
  },
  {
    question: '训练需要多长时间才能看到效果？',
    answer: '每个人的进度不同，但一般来说，坚持基础练习 2-4 周就能感受到明显的变化。关键在于持续练习和保持开放的心态，而非追求速成。我们建议将亲密发声训练视为一种长期的自我成长和关系养护方式。',
  },
  {
    question: '如果我和伴侣的发声偏好不同怎么办？',
    answer: '发声偏好不同是完全正常的，这正是沟通和相互理解的价值所在。我们建议双方坦诚交流各自的感受和偏好，寻找共同舒适的表达方式。记住，亲密发声的核心不是追求"标准"，而是找到属于你们两人独特的和谐方式。',
  },
  {
    question: '独自练习和与伴侣一起练习有什么区别？',
    answer: '两种方式各有价值。独自练习有助于建立自信、克服羞耻感、掌握基础技巧；与伴侣一起练习则能在实际互动中应用技巧、增进默契、加深情感连接。我们建议采用两者结合的方式，先独自建立基础，再与伴侣一起探索。',
  },
];

const heroImage = 'https://readdy.ai/api/search-image?query=Warm%20abstract%20artistic%20composition%20with%20flowing%20curves%20and%20soft%20gradients%20in%20warm%20rose%20and%20cream%20tones%2C%20elegant%20minimal%20design%2C%20silk%20fabric%20texture%2C%20gentle%20light%20diffusion%2C%20emotional%20and%20intimate%20atmosphere%2C%20no%20text%2C%20no%20people%2C%20abstract%20expressionism%20style%2C%20high%20resolution%20art%20photography&width=1800&height=1000&seq=hero-main-2026&orientation=landscape';

const ctaImage = 'https://readdy.ai/api/search-image?query=Soft%20abstract%20gradient%20background%20with%20warm%20rose%20gold%20and%20cream%20flowing%20shapes%2C%20elegant%20minimal%20design%2C%20diffused%20gentle%20light%2C%20romantic%20atmosphere%2C%20no%20text%2C%20no%20people%2C%20fine%20art%20photography%20high%20resolution&width=1800&height=600&seq=cta-home-2026&orientation=landscape';

export default function Home() {
  const featuredArticles = getFeaturedArticles();

  const homeJsonLd = [
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '亲密发声训练指南',
      url: 'https://auxnuyb.cn',
      description: '专业、温暖、科学的亲密发声学习平台，帮助成年伴侣提升亲密互动质量。',
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '亲密发声训练指南',
      url: 'https://auxnuyb.cn',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://auxnuyb.cn/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqItems.map((item) => ({
        '@type': 'Question',
        name: item.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: item.answer,
        },
      })),
    },
  ];

  return (
    <>
      <SEOHead
        title="亲密发声训练与表达技巧指南"
        description="围绕亲密发声主题，深入探讨声音表达、情感释放与亲密关系中的发声技巧，帮助成年伴侣了解发声的心理背景、生理机制与沟通意义，提升亲密互动质量。"
        keywords="亲密发声,亲密发声技巧,情侣声音表达,成人情感沟通,发声心理学,亲密关系提升"
        canonicalPath="/"
        ogImage={heroImage}
        jsonLd={homeJsonLd}
      />
      <ScrollToTop />
      <Navbar />

      <main>
        {/* Hero Section */}
        <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
          <img
            src={heroImage}
            alt="亲密发声训练指南 - 温暖抽象艺术背景"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/30"></div>
          <div className="relative z-10 w-full px-4 md:px-6 text-center">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white font-heading mb-4 md:mb-6 leading-tight">
              探索声音表达的<br className="md:hidden" />无限魅力
            </h1>
            <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed">
              专业、温暖、科学的亲密发声学习平台，帮助成年伴侣深入理解声音表达的心理背景、生理机制与沟通意义，提升亲密互动质量。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/category/jichu-rumen"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-book-open-line"></i>
                开始学习
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center gap-2 px-6 py-3 bg-white/10 backdrop-blur-sm text-white border border-white/20 rounded-full text-sm font-medium hover:bg-white/20 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-information-line"></i>
                了解更多
              </Link>
            </div>
          </div>
        </section>

        {/* Categories Section */}
        <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-10 md:mb-14">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
                探索学习内容
              </h2>
              <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
                五大核心板块，从基础入门到进阶技巧，全方位覆盖亲密发声的学习需求
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.id}`}
                  className="group block p-5 md:p-6 rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
                >
                  <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                    <i className={`${cat.icon} text-xl`}></i>
                  </div>
                  <h3 className="text-base md:text-lg font-semibold text-foreground-900 font-heading mb-2">
                    {cat.name}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {cat.description}
                  </p>
                  <div className="mt-4 flex items-center gap-1 text-sm text-primary-600 font-medium">
                    <span className="whitespace-nowrap">浏览文章</span>
                    <i className="ri-arrow-right-line text-xs"></i>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Featured Articles */}
        <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10 md:mb-14">
              <div>
                <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
                  精选文章
                </h2>
                <p className="text-sm md:text-base text-foreground-600">
                  编辑推荐的高质量内容，助您快速入门
                </p>
              </div>
              <Link
                to="/category/jichu-rumen"
                className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap"
              >
                查看全部文章
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {featuredArticles.map((article) => {
                const cat = categories.find((c) => c.id === article.categoryId);

                return (
                  <Link
                    key={article.id}
                    to={`/article/${article.slug}`}
                    className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
                    data-product-shop
                  >
                    <div className="relative w-full h-48 overflow-hidden">
                      <img
                        src={article.imageUrl}
                        alt={article.title}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      />
                    </div>
                    <div className="p-4 md:p-5">
                      <div className="flex items-center gap-2 mb-3">
                        {cat && (
                          <span className="px-2.5 py-0.5 text-xs rounded-full bg-primary-100 text-primary-700 font-medium whitespace-nowrap">
                            {cat.name}
                          </span>
                        )}
                        <span className="text-xs text-foreground-500 whitespace-nowrap">{article.readTime}</span>
                      </div>
                      <h3 className="text-sm md:text-base font-semibold text-foreground-900 font-heading mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                        {article.title}
                      </h3>
                      <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                        {article.excerpt}
                      </p>
                      <div className="mt-4 flex items-center justify-between">
                        <span className="text-xs text-foreground-500 whitespace-nowrap">{article.author}</span>
                        <span className="text-xs text-foreground-400 whitespace-nowrap">{article.date}</span>
                      </div>
                    </div>
                  </Link>
                );
              })}
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
          <div className="max-w-3xl mx-auto">
            <div className="text-center mb-10 md:mb-14">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
                常见问题
              </h2>
              <p className="text-sm md:text-base text-foreground-600">
                关于亲密发声训练，您可能想知道的问题
              </p>
            </div>

            <div className="flex flex-col gap-3">
              {faqItems.map((item, index) => (
                <details key={index} className="group rounded-lg bg-background-100 border border-background-200/70 overflow-hidden">
                  <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                    <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                      {item.question}
                    </span>
                    <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 rounded-full bg-background-200 text-foreground-500 group-open:bg-primary-100 group-open:text-primary-600 transition-colors">
                      <i className="ri-add-line text-sm group-open:before:content-['\f1af']"></i>
                    </div>
                  </summary>
                  <div className="px-5 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {item.answer}
                    </p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="relative py-14 md:py-20 px-4 md:px-6 overflow-hidden">
          <img
            src={ctaImage}
            alt=""
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/35"></div>
          <div className="relative z-10 max-w-2xl mx-auto text-center">
            <h2 className="text-2xl md:text-3xl font-bold text-white font-heading mb-4">
              准备好开启您的声音表达之旅了吗？
            </h2>
            <p className="text-sm md:text-base text-white/80 mb-8 leading-relaxed">
              加入我们的学习社区，探索声音表达的无限可能，让每一次亲密互动都更加丰富和真实。
            </p>
            <Link
              to="/category/jichu-rumen"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              立即开始学习
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}